export const pricingTiers = [
  {
    name: 'Free',
    price: '$0/mo',
    priceNum: 0,
    features: ['1K memory ops/mo', '10MB storage', '1 agent', 'Semantic recall', 'Community support'],
    cta: 'Get Started',
    variant: 'secondary' as const,
    highlighted: false,
  },
  {
    name: 'Developer',
    price: '$39/mo',
    priceNum: 39,
    features: ['10K memory ops/mo', '100MB storage', '3 agents', 'Session snapshots', 'LangChain adapter', 'Email support'],
    cta: 'Start Free Trial',
    variant: 'primary' as const,
    highlighted: false,
  },
  {
    name: 'Pro',
    price: '$129/mo',
    priceNum: 129,
    features: ['100K memory ops/mo', '1GB storage', '10 agents', 'Cross-provider transfer', 'Conflict resolution', 'Priority support', 'SLA 99.9%'],
    cta: 'Start Free Trial',
    variant: 'primary' as const,
    highlighted: true,
    badge: 'Most Popular',
  },
  {
    name: 'Team',
    price: '$349/mo',
    priceNum: 349,
    features: ['Unlimited memory ops', '10GB storage', 'Unlimited agents', 'Custom backends (self-host)', 'Full audit log', 'Dedicated support', 'SLA 99.9%'],
    cta: 'Contact Sales',
    variant: 'secondary' as const,
    highlighted: false,
  },
];
